<template>
	<div v-if="this.$store.state.companyInfoLoading" class="spinner-border" role="status" />
	<ul class="list-group">
		<li v-for="(value, name) in company" class="list-group-item">
			<strong>{{ getTrueName(name) }}</strong>: {{ value }}
		</li>
	</ul>
</template>

<script>
export default {
	name: 'Info',
	props: {
		company: Object
	},
	computed: {
	},
	methods: {
		getTrueName(name){
			switch (name) {
				case "fedOkrug":
					return "Регион"
				case "companyType":
					return "Формат клиента"
				case "managerFOPR":
					return "Ведущий менеджер ПР"
				case "managerFOPT":
					return "Ведущий менеджер РТ"
				case "managerFOAQ":
					return "Ведущий менеджер Аквант"
				default:
					console.log('Не найдена расшифровка поля')
			}
		}
	}
}
</script>

<style scoped>
	
</style>